import { HomeResident } from 'src/models/resort/HomeResident';

// NPC別荘の住民名に敬称をつける関数
// 施工事例詳細ページでは、特定の言語のみ、住民の名前に敬称を付与する
// 一部の特殊NPCについては、例外的な対応をする必要がある
// 詳しくは仕様ページを参照：https://spdlybra.nintendo.co.jp/confluence/pages/viewpage.action?pageId=1171659946

export function getHonorificNpcNameInJapanese(npc: HomeResident) {
  if (npc.npcType === 1) {
    return npc.name + 'さま';
  } else if (npc.npcType === 2) {
    switch (npc.npcId) {
      // えきいんさん(19),おまわりさんB(30),おまわりさんA(32)、マスター(28,73)
      // 敬称をつけない
      case 19:
      case 30:
      case 32:
      case 28:
      case 73:
        return npc.name;
      // カメヤマさん(6)、ラケットさん(20)、リセットさん(21)、ホンマさん(22)
      // 名前の'さん'を'さま'に置換
      case 6:
      case 20:
      case 21:
      case 22:
        return npc.name.replace('さん', 'さま');
      // まいこちゃん(46)
      // 名前の'ちゃん'を'さま'に置換
      case 46:
        return npc.name.replace('ちゃん', 'さま');
      default:
        return npc.name + 'さま';
    }
  } else {
    return '';
  }
}

export function getHonorificNpcNameInKorean(npc: HomeResident) {
  if (npc.npcType === 1) {
    return npc.name + '님';
  } else if (npc.npcType === 2) {
    switch (npc.npcId) {
      // ラケットさん(오루묵씨)(20)、リセットさん(도루묵씨)(21)、ホンマさん(안심해씨)(22)
      // 名前の'씨'を'님'に置換
      case 20:
      case 21:
      case 22:
        return npc.name.replace('씨', '님');
      default:
        return npc.name + '님';
    }
  } else {
    return '';
  }
}
